import clsx from 'clsx'
import React from 'react'

import {BaseProps} from '../types'
import {forwardOverridableRef} from '../util'
import {ClassKey, useClasses} from './Logo.classes'
import {Brand, Lang} from './types'

export type LogoTypeMap = {
  props: {
    brand: Brand
    lang: Lang
    invert?: boolean
  }
  defaultComponent: 'span'
  classKey: ClassKey
}

export type LogoProps = BaseProps<LogoTypeMap>

const Logo = forwardOverridableRef<LogoTypeMap>((props, ref) => {
  const {
    component: Component = 'span',
    classes: classesProp,
    className: classNameProp,
    brand,
    lang,
    invert,
    ...componentProps
  } = props
  const classes = useClasses(classesProp)
  const className = clsx(
    classes.root,
    classes[`brand_${brand === 'yango' ? 'yango' : 'yandex'}`],
    lang !== 'ru' && classes.lang_en,
    invert && classes.invert,
    classNameProp,
  )

  return <Component {...componentProps} ref={ref} className={className} />
})

export default Logo
